import React from 'react';
import {
  BOAT,
  YACHT,
  SAILBOAT,
  PONTOON,
  CATAMARAN,
  JON_BOAT,
  PWC,
  INFLATABLE,
  CANOE_KAYAK
} from 'constants/boatApplication';
import Info from 'Components/Info';
import NotificationManager from 'dom-managers/notification';

export default class SelectBoat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelectBoatType = type => () => {
    const {boat, selectBoatType, markStepAsRedacted, goToStep} = this.props;
    if (boat.status && boat.status !== 'DRAFT' && boat.boatType !== type) {
      NotificationManager.error(400, 'Boat Type can only be changed in the application in the Draft status');
    } else {
      markStepAsRedacted();
      selectBoatType(type)
        .then(() => {
          goToStep('next', true);
        });
    }
  };

  toggleBoatYachtSelector = (type = BOAT) => {
    this.setState(prevState => {
      return ({
        expandedBoatType: prevState.expandedBoatType === type ? null : type,
        lastExpandedBoatType: type
      });
    });
  };

  getChosenBoatTypeMarkClass = type => {
    const {boat} = this.props;
    return type === boat.boatType ? 'selected' : '';
  };

  getVisibilityClassForBoatType = () => {
    return this.state.expandedBoatType ? 'hide' : 'show';
  };

  getAnimationClassForBoat = (type = BOAT) => {
    const {expandedBoatType, lastExpandedBoatType} = this.state;
    if (expandedBoatType) return expandedBoatType === type ? 'move-center' : 'hide';
    return lastExpandedBoatType === type ? 'move-back' : 'show';
  };

  getSubAnimationClassForBoat = (type = BOAT) => {
    return this.state.expandedBoatType === type ? 'show-sub-type' : 'none-display';
  };

  render() {
    const {expandedBoatType} = this.state;
    const {getHeader} = this.props;

    return (
      <React.Fragment>
        {getHeader()}
        <section className='scene_section boat-type-section _jc_center'>
          <section
            className={`boat-type-banner boat ${this.getAnimationClassForBoat()} ${this.getChosenBoatTypeMarkClass(
              BOAT
            )} ${this.getChosenBoatTypeMarkClass(YACHT)}`}
            onClick={() => this.toggleBoatYachtSelector(BOAT)}
          >
            <section
              className={`boat-sub-type-banner boat to-left ${this.getSubAnimationClassForBoat()} ${this.getChosenBoatTypeMarkClass(
                BOAT
              )}`}
              onClick={this.handleSelectBoatType(BOAT)}
            >
              <div className='image' />
              <div className='title'>BOAT</div>
              <div className='description'>Less than 26 Ft. Long</div>
            </section>
            <section
              className={`boat-sub-type-banner yacht to-right ${this.getSubAnimationClassForBoat()} ${this.getChosenBoatTypeMarkClass(
                YACHT
              )}`}
              onClick={this.handleSelectBoatType(YACHT)}
            >
              <div className='image' />
              <div className='title'>YACHT</div>
              <div className='description'>26 Ft. and longer</div>
            </section>

            <section className='for-hover'>
              <div className='image' />
              <div className='image-background' />
              <div className='title'>
                <div />
                {expandedBoatType === BOAT ? 'BACK' : 'BOAT / YACHT'}
              </div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    <p>
                      Boat refers to a watercraft less than 26 feet in length and capable of being mechanically powered.
                    </p>
                    <p>
                      Yacht refers to a watercraft 26 feet in length or longer and capable of being mechanically
                      powered.
                    </p>
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner sailboat ${this.getVisibilityClassForBoatType(
              SAILBOAT
            )}  ${this.getChosenBoatTypeMarkClass(SAILBOAT)}`}
            onClick={this.handleSelectBoatType(SAILBOAT)}
          >
            <section className='for-hover'>
              <div className='image' />
              <div className='title'>SAILBOAT</div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    Sailboat: a boat designed or intended to use sails as the primary means of propulsion.
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner pontoon ${this.getVisibilityClassForBoatType(
              PONTOON
            )}  ${this.getChosenBoatTypeMarkClass(PONTOON)}`}
            onClick={this.handleSelectBoatType(PONTOON)}
          >
            <section className='for-hover'>
              <div className='image' />
              <div className='title'>PONTOON</div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    Pontoon refers to a boat consisting of a rigid structure connecting at least two parallel sealed
                    buoyancy chambers. The line of intersection of the buoyancy chambers and water surface produce more
                    than a single closed curve when loaded to the maximum weight capacity.
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner catamaran ${this.getAnimationClassForBoat(
              CATAMARAN
            )}  ${this.getChosenBoatTypeMarkClass(CATAMARAN)}`}
            onClick={() => this.toggleBoatYachtSelector(CATAMARAN)}
          >
            <section
              className={`boat-sub-type-banner catamaran to-left ${this.getSubAnimationClassForBoat(CATAMARAN)} ${this.getChosenBoatTypeMarkClass(CATAMARAN)}`}
              onClick={this.handleSelectBoatType(CATAMARAN)}
            >
              <div className='image' />
              <div className='title'>CATAMARAN</div>
              <div className='description'>Less than 26 Ft. Long</div>
            </section>
            <section
              className={`boat-sub-type-banner yacht to-right ${this.getSubAnimationClassForBoat(CATAMARAN)} ${this.getChosenBoatTypeMarkClass(YACHT)}`}
              onClick={this.handleSelectBoatType(YACHT)}
            >
              <div className='image' />
              <div className='title'>YACHT</div>
              <div className='description'>26 Ft. and longer</div>
            </section>
            <section className='for-hover'>
              <div className='image' />
              <div className='image-background' />
              <div className='title'>
                <div />
                {expandedBoatType === CATAMARAN ? 'BACK' : 'CATAMARAN'}
              </div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    <p>
                      Catamaran: a hull with two running surfaces separated by a section that is above the running
                      surfaces. Select Catamaran for watercraft less than 26 feet in length.
                    </p>
                    <p>Select Yacht for watercraft 26 feet in length or longer.</p>
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner jonboat ${this.getVisibilityClassForBoatType(
              JON_BOAT
            )}  ${this.getChosenBoatTypeMarkClass(JON_BOAT)}`}
            onClick={this.handleSelectBoatType(JON_BOAT)}
          >
            <section className='for-hover'>
              <div className='image' />
              <div className='title'>JONBOAT</div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    Jon Boat refers to a small flat-bottomed watercraft capable of being powered mechanically or by
                    manual or sailing means.
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner pwc ${this.getVisibilityClassForBoatType(
              PWC
            )}  ${this.getChosenBoatTypeMarkClass(PWC)}`}
            onClick={this.handleSelectBoatType(PWC)}
          >
            <section className='for-hover'>
              <div className='image' />
              <div className='title'>PWC</div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    PWC (Personal watercraft) is a vessel that uses an internal combustion engine powering a water jet
                    pump as its primary source of propulsion and is designed to be operated by a person or persons
                    sitting, standing, or kneeling on, rather than within, the confines of a hull.
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner inflatable ${this.getVisibilityClassForBoatType(
              INFLATABLE
            )}  ${this.getChosenBoatTypeMarkClass(INFLATABLE)}`}
            onClick={this.handleSelectBoatType(INFLATABLE)}
          >
            <section className='for-hover'>
              <div className='image' />
              <div className='title'>INFLATABLE</div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    Inflatable refers to a boat that achieves all or part of its intended structure, shape and buoyancy
                    through the medium of inflation.
                  </div>
                }
              />
            </section>
          </section>

          <section
            className={`boat-type-banner kayak-canoe ${this.getVisibilityClassForBoatType(
              CANOE_KAYAK
            )}  ${this.getChosenBoatTypeMarkClass(CANOE_KAYAK)}`}
            onClick={this.handleSelectBoatType(CANOE_KAYAK)}
          >
            <section className='for-hover'>
              <div className='image' />
              <div className='title'>KAYAK / CANOE</div>
              <Info
                triggerWrapperClassName='_position_absolute _top_15 _left_5  _z_index_200'
                triggerElement={<div className='boat-info-mark __info-icon' />}
                popperElement={
                  <div className='info__tooltip-body'>
                    <p>
                      Canoe - a watercraft that is designed to be manually propelled, with or without provision for
                      auxiliary power, with neither end having a transverse dimension greater than 45% of its maximum
                      beam and conforms to the following rules:
                    </p>
                    <div>
                      <ul>
                        <li>Canoe Length 14 ft. (4.25m) or less: Maximum Beam 1/3 Canoe Length</li>
                        <li>Canoe Length over 14 ft. to 16 ft. (4.9m): Maximum Beam 1/4 Canoe Length</li>
                        <li>Canoe Length over 16 ft. (over 4.9m): Maximum Beam 1/5 Canoe Length</li>
                      </ul>
                    </div>
                    <p>
                      Kayak - a watercraft designed to be manually propelled, typically without provision for auxiliary
                      power, with the occupant intended to be seated with legs approximately 90° from the torso.
                    </p>
                  </div>
                }
              />
            </section>
          </section>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/BoatTypeSelect.jsx